export const API_URL = import.meta.env.VITE_API_URL as string;
export const IS_DEV = import.meta.env.DEV;
